import { isEmbedMode } from "../../utils/embed";
import styles from "./AuthPageShell.module.scss";

export const AUTH_DESKTOP_BG = `${process.env.PUBLIC_URL}/images/login-desktop-bg.png`;

/**
 * Shared full-viewport layout for IdP flows: campaign background + right column (9:16 desktop).
 * Pass scrollable body as children; optional footer renders inside the panel (e.g. docked button).
 * scrollFooterReserve: extra bottom padding when a docked footer exists or fixed CTAs below scroll (default true).
 * In WordPress iframe embed (?embed=1), skips heavy background imagery for faster load.
 */
const AuthPageShell = ({
	children,
	footer = null,
	scrollFooterReserve = true,
}) => {
	const embed = isEmbedMode();
	const scrollClass = scrollFooterReserve
		? styles.authPanelScroll
		: styles.authPanelScrollCompact;
	const shellClass = embed
		? `${styles.authShell} ${styles.authShellEmbed}`
		: styles.authShell;
	const panelClass = embed
		? `${styles.authPanel} ${styles.authPanelEmbed}`
		: styles.authPanel;

	return (
		<div
			className={shellClass}
			style={
				embed
					? undefined
					: { backgroundImage: `url(${AUTH_DESKTOP_BG})` }
			}
		>
			<div className={panelClass}>
				<div className={scrollClass}>{children}</div>
				{footer}
			</div>
		</div>
	);
};

export default AuthPageShell;
